<template>
  <section>
    <NavBar />
    <div class="columns">
      <div class="column">
        <h2 class="title">Clientes</h2>
      </div>
    </div>
  </section>
</template>

<script>
import NavBar from "@/components/NavBar.vue";

export default {
  name: "Customers",
  components: {
    NavBar,
  },
};
</script>

<style lang="scss" module></style>
